<div class="login-page d-flex align-items-center justify-content-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-5 col-xl-5">
        <div class="login-card shadow-lg">
          <div class="text-center login-header">
            <img src="assets/images/logo.png" alt="Diagnostic Learning Services" class="img-fluid logo-img" />
            <h3 class="heading mt-4">Sign in</h3>
            <p class="text-muted small">Access your account to manage appointments</p>
          </div>

          <form [formGroup]="loginForm" id="login_form" class="custom-form mt-4" (ngSubmit)="onSubmit()">
            <div *ngIf="message" class="alert alert-danger py-2 small mb-4">
              <i class="pi pi-exclamation-circle mr-2"></i> {{message}}
            </div>

            <div class="form-group mb-4">
              <div class="input-group" [class.is-invalid-group]="(f['username'].touched || submitted) && f['username'].invalid">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="pi pi-user"></i></span>
                </div>
                <input type="text" formControlName="username" class="form-control" placeholder="Username" />
              </div>
              <div *ngIf="(f['username'].touched || submitted) && f['username'].invalid" class="text-danger small mt-1 ml-2">
                Username is required.
              </div>
            </div>

            <div class="form-group mb-4">
              <div class="input-group" [class.is-invalid-group]="(f['password'].touched || submitted) && f['password'].invalid">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="pi pi-lock"></i></span>
                </div>
                <input type="password" formControlName="password" class="form-control" placeholder="Password" />
              </div>
              <div *ngIf="(f['password'].touched || submitted) && f['password'].invalid" class="text-danger small mt-1 ml-2">
                Password is required.
              </div>
            </div>

            <button type="submit" class="theme-button w-100 justify-content-center py-2 mt-4">
              Log In
            </button>
          </form>
        </div>
        <div class="text-center mt-4">
          <p class="text-muted small">© {{currentYear}} Diagnostic Learning Services. All rights reserved.</p>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple" [fullScreen]="true">
  </ngx-spinner>
</div>